/*
 * Copyright (c) 2018 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */
import {IComponentOptions, IFilterService, IPromise} from 'angular';
import {IStateService} from 'angular-ui-router';
import AuthServiceRS from '../../../authentication/service/AuthServiceRS.rest';
import {PageNameConstants} from '../../../core/service/PageNameConstants';
import RoleUtilService from '../../../core/service/RoleUtilService';
import VersicherungsbeitragRS from '../../../core/service/versicherungsbeitragRS.rest';
import TSUser from '../../../models/TSUser';
import TSVersicherungsbeitraegeSearchresultDTO from '../../../models/TSVersicherungsbeitraegeSearchresultDTO';
import TSVersicherungsbeitragDTO from '../../../models/TSVersicherungsbeitragDTO';
import ILogService = angular.ILogService;
import IQService = angular.IQService;
import IScope = angular.IScope;

declare let require: any;
let template = require('./versicherungsbeitraegeListView.html');

export class VersicherungsbeitraegeListViewComponentConfig implements IComponentOptions {
    transclude = false;
    template = template;
    controller = VersicherungsbeitraegeListViewController;
    controllerAs = 'vm';
    bindToController = true;
    bindings: any = {
        besitzer: '<'
    };

}

export class VersicherungsbeitraegeListViewController {

    currentPrincipal: TSUser | undefined;
    currentUsername: string | undefined;
    totalResultCount: string = '-';
    versicherungsbeitraegeList: TSVersicherungsbeitragDTO[] = [];

    static $inject: string[] = ['$filter', '$state', '$log', 'CONSTANTS', '$q', '$scope', 'AuthServiceRS', 'RoleUtilService',
        'VersicherungsbeitragRS', 'PAGE_NAMES'];

    constructor(private $filter: IFilterService,
                private $state: IStateService, private $log: ILogService, private CONSTANTS: any,
                private $q: IQService, private $scope: IScope, private authService: AuthServiceRS,
                private roleUtilService: RoleUtilService, private versicherungsbeitragRS: VersicherungsbeitragRS,
                private pageNames: PageNameConstants) {

    }

    $onInit() {
        this.currentPrincipal = this.authService.getPrincipal();
        this.currentUsername = (this.currentPrincipal !== undefined) ? this.currentPrincipal.email : undefined;

    }

    private editVersicherungsbeitrag(versicherungsbeitragDTO: TSVersicherungsbeitragDTO, event: any) {
        this.$state.go(this.pageNames.VERSICHERUNGSBEITRAGSCHADEN, {
            createNew: false,
            versicherungsbeitragId: versicherungsbeitragDTO.versicherungsbeitragId
        });
    }

    public addVersicherungsbeitrag() {
        this.$state.go(this.pageNames.VERSICHERUNGSBEITRAGSCHADEN, {createNew: true, versicherungsbeitragId: undefined});
    }

    public passVersicherungsbeitragFallFilterToServer = (tableFilterState: any): IPromise<TSVersicherungsbeitraegeSearchresultDTO> => {
        this.$log.debug('Triggering ServerFiltering with Filter Object', tableFilterState);
        return this.versicherungsbeitragRS.searchVersicherungsbeitraege(tableFilterState).then((response: TSVersicherungsbeitraegeSearchresultDTO) => {
            this.totalResultCount = response.totalResultSize ? response.totalResultSize.toString() : '-';
            this.versicherungsbeitraegeList = response.versicherungsbeitragDTOs;
            return response;
        });

    };
}



// WEBPACK FOOTER //
// ./src/app/versicherungsbeitraege/component/versicherungsbeitragListView/versicherungsbeitraegeListView.ts